import React, { Component } from "react";
import { connect } from "react-redux";
import {
  deleteNewsItem,
  loadNewsItem,
  openNewsModal,
  isimportant,
} from "ActionsNews";
import { showError, showSuccess } from "ReduxErrorBar";
import { checkContentDashboardStatus } from "GeneralTabAction";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { BASE_IMAGES_URL, COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class NewsListItem extends Component {
  deleteNewsCallback(newsitem) {
    confirmAlert({
      title: LocaleStrings.content_delete,
      message: LocaleStrings.content_news_dlt_message,
      confirmLabel: LocaleStrings.content_ok,
      cancelLabel: LocaleStrings.content_cancel,
      buttons: [
        {
          label: LocaleStrings.content_ok,
          onClick: () => {
            var newsitemid = this.props.newsitem.newsid;
            this.props.deleteNewsItem(
              this.props.session,
              newsitemid,
              (result) => {
                if (result.error) {
                  this.props.showError(COMMON_FAIL_MESSAGE);
                } else {
                  this.props.showSuccess(LocaleStrings.content_news_dlt);
                  this.props.checkContentDashboardStatus(this.props.session);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.content_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  editNewsCallback(obj) {
    var newsitem = this.props.newsitem;

    this.props.loadNewsItem(newsitem);
    this.props.openNewsModal({ showModal: true });
  }

  createMarkup() {
    var { newsitem } = this.props;
    var content = "";
    if (newsitem.newscontent)
      content =
        newsitem.newscontent.length > 100
          ? newsitem.newscontent.substring(0, 100) + "..."
          : newsitem.newscontent;

    return { __html: content };
  }

  important = () => {
    let { newsitem, session } = this.props;
    let imp = true;
    if (newsitem && newsitem.featured) {
      imp = false;
    }

    this.props.isimportant(session, newsitem, imp, (response) => {
      if (!response.success) {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
    });
  };

  render() {
    var { newsitem } = this.props;
    var imgURL = "../../style/images/placeholder_600x400.svg";
    if (newsitem.newsthumbimage !== "" && newsitem.newsthumbimage !== undefined)
      imgURL = `${BASE_IMAGES_URL}/${newsitem.newsthumbimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
    else if (newsitem.newsimage !== "" && newsitem.newsimage !== undefined)
      imgURL = `${BASE_IMAGES_URL}/${newsitem.newsimage}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;

    var iconURL = `../../style/images/custom-icons/compound-shape.svg`;
    if (newsitem.featured) {
      iconURL = `../../style/images/custom-icons/compound-shape-copy.svg`;
    }

    var style = {
      width: "30px",
      height: "30px",
      backgroundImage: `url(${imgURL})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "5px",
      backgroundPosition: "50% 50%",
      marginTop: "5px",
      marginBottom: "5px",
    };
    return (
      <tr key={newsitem.newsid}>
        <td>
          <div className="row">
            <div className="col-md-12 col-lg-12 d-flex">
              <div style={style}></div>
              <div
                style={{ textAlign: "left", paddingLeft: 20, paddingTop: 8 }}
              >
                <img
                  onClick={this.important}
                  className="i-custom-star"
                  src={iconURL}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          </div>
        </td>
        <td>
          <div className="row">
            <div
              className="col-md-12 col-lg-12"
              style={{ padding: "0px auto 0px 16px" }}
            >
              <div>
                {newsitem.newstitle.length > 80
                  ? newsitem.newstitle.substring(0, 80) + "..."
                  : newsitem.newstitle}
              </div>
              <div
                className="news-content"
                style={{ color: "#838aa0", marginBottom: 0 }}
                dangerouslySetInnerHTML={this.createMarkup()}
              ></div>
            </div>
          </div>
        </td>
        <td>
          <div className="action-button-area">
            <div className="action-button">
              <button
                className="btn btn-custom-table-white"
                onClick={this.editNewsCallback.bind(this)}
              >
                Edit
              </button>
            </div>
            <div className="action-button">
              <button
                className="i-custom-table-delete"
                onClick={this.deleteNewsCallback.bind(this)}
              >
                <img
                  className="button-delete-icon"
                  src="../../style/images/delete.png"
                />
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  deleteNewsItem,
  loadNewsItem,
  openNewsModal,
  showError,
  showSuccess,
  checkContentDashboardStatus,
  isimportant,
})(NewsListItem);
